import Skeleton from "react-loading-skeleton";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import classes from "./styles.module.scss";

import { useInviteToken } from "@api/videoVisit";
import {
  SendInviteEmail,
  useVideoVisitStore,
} from "@components/organisms/videoVisit";
import { Icon } from "@components/atoms/icons";
import { copyTextToClipboard } from "@utils";
import { path } from "@/routes/path";
import type { IInviteGuestProps } from "@components/organisms/videoVisit/components/inviteGuest/types";

export function InviteGuest({ id }: IInviteGuestProps) {
  const { t } = useTranslation("form");

  const videoVisitAppointmentId = useVideoVisitStore(
    (state) => state.appointmentId,
  )!;
  const appointmentId = id || videoVisitAppointmentId;
  const { data } = useInviteToken({ variables: { appointmentId } });

  const token = data?.data?.data?.token;

  const url = `${window.location.origin}${path.guestJoin.join.link(
    token || "",
  )}`;

  return (
    <div className={clsx(classes.inviteGuest)}>
      <div className={clsx(classes.inviteGuest__link)}>
        {token ? (
          <div
            className={clsx(classes.inviteGuest__linkInside)}
            onClick={() => copyTextToClipboard(url, t)}
          >
            <div className={clsx(classes.inviteGuest__text)}>{url}</div>
            <div>
              <Icon name={"Copy"} />
            </div>
          </div>
        ) : (
          <Skeleton width={"100%"} height={"100%"} />
        )}
      </div>
      <div>
        <SendInviteEmail id={id} />
      </div>
    </div>
  );
}
